import React, { useMemo } from 'react';
import classnames from 'classnames';
import { TableColumn } from 'tea-component';
import ReportTable from '../../../components/ReportTable';
import useDPSReportModule from '../../../_hooks/useDPSReportModule';
import { addMockIdBatch, getRecordKeyOfMockable } from '@gp/utils/common';
import { CARD_TITLE, buildRecord, removeDuplicatedHightlights, getColumns } from './utils';

import type { IBaseProps } from '@home/types/common';
import type {
  IDPSReportHightlightVO,
  IDPSReportHightlightDTO,
  ICommonProjectMilestoneDTOV2,
} from '@gp/types/dpsReport/v2';

interface IHightlightsProps extends IBaseProps {
  // 是否loading
  isLoading?: boolean;
  // 是否表格内部loading
  isInnerLoading?: boolean;
  // projects集合数据、及其关联的milestones集合数据
  projectsMilestones?: ICommonProjectMilestoneDTOV2[];
  // 点击Refresh Data按钮的回调
  onRefreshData?: () => void;
  // 模块数据
  value: IDPSReportHightlightVO[];
  // 模块数据更新，删除后立马更新，新增后 需要等新增这条数据编辑完整后 才会更新，页面就不需要考虑不完整的脏数据了
  onChange?: (payload: IDPSReportHightlightVO[]) => void;
}

const Hightlights: React.FC<IHightlightsProps> = (props) => {
  const { style, className, isLoading, isInnerLoading, projectsMilestones, onRefreshData, value, onChange } = props;

  const { records, setRecords, onAdd, onDelete } = useDPSReportModule<IDPSReportHightlightVO>({
    buildRecord,
    value,
    onChange,
  });

  const columns: TableColumn<IDPSReportHightlightVO>[] = useMemo(() => {
    const projects = projectsMilestones?.map((item) => {
      const { project_id: projectId, project } = item || {};
      return {
        text: project || '',
        value: projectId || '',
      };
    });
    return getColumns({
      projects: projects || [],
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onProjectChange: async (payload: string) => {
        try {
          const project = projectsMilestones?.find((item) => {
            const { project_id: projectId } = item || {};
            return projectId === payload;
          });
          const projectMilestones = project?.details?.map((item) => ({ ...project, ...item }));
          /**
           * 针对即将来临的Hightlights集合，进行去重处理
           * 1、即将来临的Hightlights集合 内部去重，根据getHightlightRepeatCheckKey方法生成的 重复判定标准去重
           * 2、结合当前的Hightlights集合 进行去重，过滤掉当前Hightlights集合中已有的，根据getHightlightRepeatCheckKey方法生成的 重复判定标准去重
           */
          const removedDuplicateData = removeDuplicatedHightlights(projectMilestones, records);
          const recordsComming = addMockIdBatch<IDPSReportHightlightDTO>(removedDuplicateData);
          const recordsTmp = [...records.slice(0, records.length - 1), ...recordsComming];
          setRecords(recordsTmp);
          onChange?.(recordsTmp);
        } catch (exception) {}
      },
    });
  }, [projectsMilestones, records, onChange]);

  return (
    <ReportTable
      showRefreshData
      style={style}
      className={classnames('dbg-dps-report__hightlights-table-card', className)}
      title={CARD_TITLE}
      isLoading={isLoading}
      isInnerLoading={isInnerLoading}
      // addBtnTips=""
      columns={columns}
      records={records}
      recordKey={getRecordKeyOfMockable}
      onAdd={onAdd}
      onDelete={onDelete}
      onRefreshData={onRefreshData}
    />
  );
};

export default Hightlights;
